import React from 'react';
import {useTheme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {IMessagePanelProps, MsgBoxType} from "./types";
import Icon from "@mui/material/Icon";


export const MessagePanel: React.FC<IMessagePanelProps> = (
    {
        title = "",
        message = "",
        type = undefined
    }: IMessagePanelProps
) => {
    const theme = useTheme();

    let iconColor: MsgBoxType = "inherit";
    let iconName: string | undefined = undefined;

    switch (type) {
        case "error":
            iconColor=type;
            iconName="cancel_rounded_icon";
            break;
        case "warning":
            iconColor=type;
            iconName="warning_rounded_icon";
            break;
        case "info":
            iconColor=type;
            iconName="info_rounded_icon";
            break;
        default:
            break;
    }
    return (
        <>
            <Box display="flex" alignItems={"end"} justifyContent={"start"} >
                {iconName &&
                    <Icon
                        color={iconColor}
                        sx={{
                            fontSize: theme.spacing(4.5),
                            mr: theme.spacing(3),
                        }}
                    >
                        {iconName}
                    </Icon>
                }
                <Typography variant="h6">{title}</Typography>
            </Box>
            <Box>
                <Typography variant="body1">{message}</Typography>
            </Box>
        </>
    );
}